import { mapGetters, mapActions } from "vuex";
import Velocity from "velocity-animate";
import FilterSection from "@/components/Synonym/SynonymFilter/FilterSection/FilterSection.vue";
import FilterOptions from "@/components/Synonym/SynonymFilter/FilterOptions/FilterOptions.vue";
import OrderOptions from "@/components/Synonym/SynonymFilter/OrderOptions/OrderOptions.vue";

export default {
    components: { FilterSection, FilterOptions, OrderOptions },
    data() {
        return {
            activeAd: false,
            mobileAdHeight: 0
        };
    },
    computed: {
        ...mapGetters("ThesaurusFilter", [
            "getActiveFiltersAmount",
            "getFiltersObj",
            "getThesaurusLength",
            "isMobileFilterPanelOpened"
        ]),
        showResultsBtnText() {
            return `${this.$t("showResults")} <span>(${this.getThesaurusLength})</span>`;
        }
    },
    watch: {
        isMobileFilterPanelOpened() {
            if (this.isMobileFilterPanelOpened) {
                this.setPanelHeight();
            }
        }
    },
    methods: {
        ...mapActions("ThesaurusFilter", ["toggleMobileFilterPanel", "clearActiveFilters"]),
        setPanelHeight() {
            const adNode = document.getElementById("YD_Thesaurus_728");
            const height = adNode.offsetHeight ? adNode.offsetHeight + 1 : 0;
            this.activeAd = !!height;
            this.mobileAdHeight = `calc(100vh - ${height}px)`;
        },
        // Filter panel animation
        beforeEnterOverlay(el) {
            el.style.opacity = 0;
        },
        enterOverlay(el, done) {
            Velocity(el, { opacity: "1" }, { duration: 150 }, { complete: done });
        },
        leaveOverlay(el, done) {
            Velocity(el, { opacity: "0" }, { delay: 120, duration: 150 }, { complete: done });
        },
        enterPanel(el, done) {
            Velocity(el, { translateX: "-105%" }, { duration: 5 });
            Velocity(el, { translateX: "0%" }, { duration: 250, delay: 70 }, { complete: done });
        },
        leavePanel(el, done) {
            Velocity(el, { translateX: "-105%" }, { duration: 250 }, { complete: done });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Synonym/SynonymFilter/MobileSynonymFilter/MobileSynonymFilter.js